import { RegisterComplete, SignUpWizard, VerifyEmail } from '@components/registration'
import { Route, Switch } from 'react-router-dom'

/**
 * Public self-serve sign-up (no login), one page since 2026-10-22: /register (package → shop → account, the email
 * confirmed with a code) → Stripe Checkout → /register/complete. /register/plan?token=… (a cancelled Checkout, or an
 * older email link) opens the same page at "choose a package"; /register/verify still finishes sign-ups started with
 * an email link. Mounted as a plain Route, like /reset.
 */
export const RegisterPage = () => (
  <Switch>
    <Route path='/register/verify' component={VerifyEmail} />
    <Route path='/register/plan' component={SignUpWizard} />
    <Route path='/register/complete' component={RegisterComplete} />
    <Route path='/register' component={SignUpWizard} />
  </Switch>
)
